import apiClient from "../../clients/apiClient";
import API_ENDPOINTS from "../../config/apiEndpointsConfig";

export const sendSupportEmail = async data => {
  const endpoint = API_ENDPOINTS.SEND_SUPPORT_EMAIL();
  try {
    const response = await apiClient.post(endpoint, data);
    return response;
  } catch (error) {
    throw new Error(`Error sending support email: ${error.message}`);
  }
};
